import React, { useState, useRef, useEffect } from 'react'
import useTranslation from '../../hooks/useTranslation'
import Headline from './Headline'

function ContactButton({ label }: { label?: string }) {
  const t = useTranslation()
  const [open, setOpen] = useState(false)
  const wrapperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    function handleClickOutside(event: MouseEvent) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [open])

  const f = t.landing.footer
  const c = t.landing.contact

  return (
    <div ref={wrapperRef} className="relative">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="inline-block w-fit px-3 py-0 text-lg text-blue bg-cyan hover:bg-white border border-cyan hover:border-blue transition-all focus:outline-none focus:ring-2 focus:ring-cyan focus:ring-offset-2"
        aria-expanded={open}
        aria-haspopup="true"
      >
        {label || t.landing.cta.jetztAnfragen}
      </button>

      {open && (
        <div className="absolute right-0 top-full z-50 mt-2 w-fit bg-white p-10 shadow-lg" role="dialog" aria-label={c.popoverHeadline}>
          <Headline size="small" headline={c.popoverHeadline} className="font-thin" />

          <div className="space-y-3 mt-3">
            <p className="text-lg text-blue whitespace-nowrap">
              <span className="font-bold">{c.popoverPhoneLabel}</span>{' '}
              <a href={f.phoneHref} className="text-blue underline hover:no-underline  whitespace-nowrap" onClick={() => setOpen(false)}>
                {f.phone}
              </a>
            </p>
            <p className="text-lg text-blue whitespace-nowrap">
              <span className="font-bold">{c.popoverEmailLabel}</span>{' '}
              <a href={f.emailHref} className="text-blue underline hover:no-underline  whitespace-nowrap" onClick={() => setOpen(false)}>
                {f.email}
              </a>
            </p>
          </div>

          {/* <a
            href={c.popoverCtaHref}
            className="mt-6 block w-full whitespace-nowrap bg-cyan px-5 py-3 text-center text-lg font-medium text-white no-underline shadow-sm hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-blue focus:ring-offset-2"
            onClick={() => setOpen(false)}
          >
            {c.popoverCtaLabel}
          </a> */}
        </div>
      )}
    </div>
  )
}

export default ContactButton
